import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_REC011_Request,
  IAPI_REC011_Response,
  IAPI_REC013_Request,
  IAPI_REC013_Response,
  IAPI_REC030_Request,
  IAPI_REC030_Response,
  IAPI_COM009_Request,
  IAPI_COM009_Response,
  IAPI_COM005_Request,
  IAPI_COM005_Response,
} from "../../../type/apiType";

// 過納金一覧参照API
// API仕様書_収納・納付請求処理
const httpAPI_REC011 = async (
  param: IAPI_REC011_Request
): Promise<IAPI_REC011_Response> => {
  const res = await http.post(ApiUrl.API_REC011, {
    ...param,
  });
  return res.data;
};

// 過納金要処理一覧更新API
// API仕様書_収納・納付請求処理
const httpAPI_REC013 = async (
  param: IAPI_REC013_Request
): Promise<IAPI_REC013_Response> => {
  const res = await http.post(ApiUrl.API_REC013, {
    ...param,
  });
  return res.data;
};

// 過納金請求参照API
const httpAPI_REC030 = async (
  param: IAPI_REC030_Request
): Promise<IAPI_REC030_Response> => {
  const res = await http.post(ApiUrl.API_REC030, {
    ...param,
  });
  return res.data;
};

// 申請状況更新API
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

// 帳票ダウンロードAPI
// API仕様書_共通
const httpAPI_COM005 = async (
  param: IAPI_COM005_Request
): Promise<IAPI_COM005_Response> => {
  let res = await http.post(ApiUrl.API_COM005, {
    ...param,
  });
  return res.data;
};

// 帳票作成状況取得API
const httpAPI_COM009 = async (
  param: IAPI_COM009_Request
): Promise<IAPI_COM009_Response> => {
  let res = await http.post(ApiUrl.API_COM009, {
    ...param,
  });

  return res.data;
};

export {
  httpAPI_REC011,
  httpAPI_REC013,
  httpAPI_REC030,
  httpAPI_APP016,
  httpAPI_COM009,
  httpAPI_COM005,
};
